(function() {
  function initialiseSwatches() {
    var selectorWrappers = document.querySelectorAll('.selector-wrapper');
    var swatches = document.querySelectorAll('.swatch[data-index]');

    Array.prototype.forEach.call(swatches, function(swatch) {
      var optionIndex = Number(swatch.dataset.index);
      var selectorWrapper = selectorWrappers[optionIndex];
      var selectedInput = swatch.querySelector('input[type="radio"]:checked:not(:disabled)');
      var firstAvailableInput = swatch.querySelector('input[type="radio"]:not(:disabled)');
      var input = selectedInput || firstAvailableInput;
      var selectedText = getLabelText(input);

      if (selectorWrapper) {
        selectorWrapper.style.display = 'none';
      }

      if (input) {
        input.checked = true;
        input.setAttribute('checked', 'checked');
      }

      if (selectedText) {
        Array.prototype.forEach.call(swatch.querySelectorAll('.selected-option'), function(selectedOption) {
          selectedOption.textContent = ': ' + selectedText;
        });
      }
    });
  }

  function getLabelText(input) {
    if (!input || !input.nextElementSibling) return '';
    return input.nextElementSibling.textContent.trim();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseSwatches);
  } else {
    initialiseSwatches();
  }
})();
